import { lazyImport } from '../../../Utils/Loading/loadingHelpers'

export const Tabs = lazyImport(
  () => import(/* webpackChunkName: "mui-tabs" */ '@mui/material/Tabs'),
  <div />
)
